import { Box } from "@mui/material";
import Lookup from "./LookupModel";
import { useParams } from "react-router";
import { useMemo } from "react";

function LookupScreen() {
    const { id } = useParams();
    const baseFilters = useMemo(() => [{
        field: "LookupTypeId",
        operator: "equals",
        value: parseInt(id),
        type: "number"
    }], [id]);
    return (
        <Box>
            <Lookup.Grid baseFilters={baseFilters} />
        </Box>
    );
}

export default LookupScreen;